module.exports = __webpack_public_path__ + "img/placeholder@2x.1241bbe7.jpg";